module.exports = __webpack_public_path__ + "static/media/c6bannerModulR_small.85f3c03c.jpg";